import { PLATFORM_INFO_API, PLATFORM_INFO_API_SUPPLIER, getPlatformInfoParams, getPlatformFormComps } from '../../EditDialog-init'
import { generateSpecifications, generateSkulist } from './index'
import { _formatGoodsItem as kuaishou_formatGoodsItem } from '@/servers/prod/center/kuaishou.js'
import { _formatGoodsItem as jd_formatGoodsItem } from '@/servers/prod/center/jd.js'
import { _formatGoodsItem as wxxd_formatGoodsItem } from '@/servers/prod/center/wxxd.js'
import { _formatGoodsItem as wxsph_formatGoodsItem } from '@/servers/prod/center/wxxd.js'
import { _formatGoodsItem as xhs_formatGoodsItem } from '@/servers/prod/center/xhs.js'
import { fxgDataMap as fxg_formatGoodsItem } from '@/servers/prod/center/fxg.js'
import { pddDataMap as pdd_formatGoodsItem } from '@/servers/prod/center/pdd.js'
import { _formatGoodsItem as alibaba_formatGoodsItem } from '@/servers/prod/center/alibaba.js'


/**
 * 从列表中找到第一个未禁用的 item
 */
function findEnabled(skuList) {
    return skuList.find(item => !item.disabled);
}

/**
 * 处理 disabled 状态下的字段值
 */
function whenDisabled(val, disabled, fallback = '') {
    return disabled ? fallback : val;
}

/**
 * 铺货接口需要的skuList格式，不同平台有不同要求，通过此方法格式化
 * @param {*} platform
 * @param {*} skuList
 * @returns newSkuList
 */
function skuParamsFormat(platform, skuList) {
    const formatFns = {
        fxg() {
            const enabled = findEnabled(skuList);
            return (item) => {
                const sku = {
                    stockNum: whenDisabled(item.stockNum, item.disabled, 0),
                    skuSpecifications: item.skuSpecifications,
                    price: whenDisabled(item.price, item.disabled, enabled?.price),
                    code: whenDisabled(item.code, item.disabled),
                    outerSkuId: whenDisabled(item.outerSkuId, item.disabled),
                    weight: whenDisabled(item.weight, item.disabled),
                    skuStatus:item.skuStatus,
                };
                if (!item.disabled) sku.baseSkuId = item.id;
                (item.skuSpecifications || []).forEach((sp, idx) => {
                    sku[`specDetailName${idx + 1}`] = sp.value;
                });
                return sku;
            };
        },
        pdd() {
            const enabled = findEnabled(skuList);
            return (item) => ({
                ...item,
                multiPrice: whenDisabled(item.multiPrice, item.disabled, enabled?.multiPrice),
                singlePrice: whenDisabled(item.singlePrice, item.disabled, enabled?.singlePrice),
                quantity: whenDisabled(item.quantity, item.disabled, 0),
                weight: whenDisabled(item.weight, item.disabled),
                outSkuPlatform: whenDisabled(item.outSkuPlatform, item.disabled),
                outSkuSn: whenDisabled(item.outSkuSn, item.disabled),
                baseSkuId: item.disabled ? undefined : item.id,
            });
        },
        tb() {
            const enabled = findEnabled(skuList);
            const enabledPriceField = enabled?.skuFieldDescriptorList?.find(f => f.name === 'skuPrice');
            return (item) => {
                if (item.disabled && enabledPriceField) {
                    const priceField = item.skuFieldDescriptorList?.find(f => f.name === 'skuPrice');
                    if (priceField) priceField.defaultValue = enabledPriceField.defaultValue ?? 0;
                }
                return {
                    skuSpecifications: item.skuSpecifications,
                    skuFieldDescriptorList: item.skuFieldDescriptorList,
                    baseSkuId: item.disabled ? undefined : item.id,
                };
            };
        },
        '1688'() {
            const enabled = findEnabled(skuList);
            return (item) => ({
                price: whenDisabled(item.price, item.disabled, enabled?.price),
                skuSpecifications: item.skuSpecifications,
                amountOnSale: whenDisabled(item.stock, item.disabled, 0),
                skuFieldDescriptorList: item.skuFieldDescriptorList,
                length: item.length,
                width: item.width,
                height: item.height,
                weight: item.weight,
                baseSkuId: item.disabled ? undefined : item.id,
            });
        },
        kuaishou() {
            const enabled = findEnabled(skuList);
            return (item, index) => ({
                relSkuId: index + 1,
                skuStock: whenDisabled(item.skuStock, item.disabled, 0),
                skuSpecifications1: item.skuSpecifications1,
                skuNick: whenDisabled(item.skuNick, item.disabled),
                skuSalePrice: whenDisabled(item.skuSalePrice, item.disabled, enabled?.skuSalePrice),
                baseSkuId: item.disabled ? undefined : item.id,
            });
        },
        jd() {
            const enabled = findEnabled(skuList);
            return (item) => ({
                stockNum: whenDisabled(item.stock, item.disabled, 0),
                skuSpecifications: item.skuSpecifications,
                skuOuterId: whenDisabled(item.skuOuterId, item.disabled),
                jdPrice: whenDisabled(item.jdPrice, item.disabled, enabled?.jdPrice),
                barCode: whenDisabled(item.barCode, item.disabled, ''),
                baseSkuId: item.disabled ? undefined : item.id,
            });
        },
        wxxd() {
            const enabled = findEnabled(skuList);
            return (item) => ({
                skuSpecifications: item.skuSpecifications,
                stockNum: whenDisabled(item.stockNum, item.disabled, 0),
                skuCode: whenDisabled(item.skuCode, item.disabled),
                salePrice: whenDisabled(item.salePrice, item.disabled, enabled?.salePrice),
                marketPrice: whenDisabled(item.marketPrice, item.disabled, enabled?.marketPrice),
            });
        },
        wxsph() {
            const enabled = findEnabled(skuList);
            return (item, index) => ({
                stockNum: whenDisabled(item.stockNum, item.disabled, 0),
                skuSpecifications: item.skuSpecifications,
                skuCode: whenDisabled(item.skuCode, item.disabled),
                platformSkuCode: whenDisabled(item.platformSkuCode, item.disabled),
                salePrice: whenDisabled(item.salePrice, item.disabled, enabled?.salePrice),
            });
        },
    };

    const formatFn = formatFns[platform] || (() => item => ({ ...item, baseSkuId: item.id }));
    return skuList.map(formatFn());
}

/**
 * 铺货接口需要的整体数据，不同平台有不同要求，通过此方法格式化
 * @param {*} platform 
 * @param {*} data 
 * @returns newData
 */
function dataParamsFormat(platform, data) {
    if(platform === '1688') {
        platform = 'alibaba'
    }
    const platformFormatFns = {
        kuaishou: kuaishou_formatGoodsItem,
        jd: jd_formatGoodsItem,
        wxxd: wxxd_formatGoodsItem,
        wxsph: wxsph_formatGoodsItem,
        xhs: xhs_formatGoodsItem,
        pdd: pdd_formatGoodsItem,
        alibaba: alibaba_formatGoodsItem,
        fxg: fxg_formatGoodsItem
    }

    if (platform === 'kuaishou') {
        if (data.preSale === 1) {
            data.theDayOfDeliverGoodsTime = -1
        } else if (data.preSale === 2) {
            data.promiseDeliveryTime = -1
        }
    }

    const formatFn = platformFormatFns[platform]
    return formatFn ? formatFn(data, true) : data
}

export default {
    PLATFORM_INFO_API,
    PLATFORM_INFO_API_SUPPLIER,
    getPlatformInfoParams,
    generateSpecifications,
    generateSkulist,
    getPlatformFormComps,
    skuParamsFormat,
    dataParamsFormat
}
